import * as React from 'react';
import { useState } from 'react';
import {
    BodyMediumRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    FruitfulCustomIcon,
    H5Emphasized,
    Icon,
    Shadows,
    UsersIcon,
    View,
    YStack,
} from 'smoothie';

import BankingTerms from '../../../BankingTerms';

interface ConfirmAccountOpenProps {
    jointEmail?: string;
    showDisclosures: boolean;
    onSubmit: () => void;
    isJointInvitation: boolean;
}

const ConfirmAccountOpen = ({
    jointEmail,
    showDisclosures,
    onSubmit,
    isJointInvitation,
}: ConfirmAccountOpenProps) => {
    const [termsAccepted, setTermsAccepted] = useState<boolean>(false);
    return (
        <YStack gap={24} justifyContent="space-between">
            <View>
                <View alignSelf="center">
                    {jointEmail != null && (
                        <View
                            backgroundColor="$white"
                            padding={8}
                            borderRadius={100}
                            position="absolute"
                            zIndex={1}
                            top={-10}
                            right={-8}
                            borderColor="$gray100"
                            borderWidth={1}
                            style={{ ...Shadows.SMALL }}
                        >
                            <Icon
                                icon={UsersIcon}
                                size={20}
                                color="$gray1100"
                            />
                        </View>
                    )}
                    <FruitfulCustomIcon size="xl" showShadow />
                </View>
                <H5Emphasized textAlign="center" marginTop={24}>
                    {isJointInvitation ? 'Join' : 'Open'} your Fruitful Cash
                    Account
                </H5Emphasized>
                {jointEmail != null && (
                    <BodyMediumRegular
                        textAlign="center"
                        color="$gray1100"
                        marginBottom={36}
                    >
                        Once your account is open, we&apos;ll send an email
                        invitation to {jointEmail}.
                    </BodyMediumRegular>
                )}
            </View>

            <YStack>
                {showDisclosures && (
                    <BankingTerms
                        marginTop={8}
                        marginBottom={24}
                        termsAccepted={termsAccepted}
                        onPress={() => {
                            setTermsAccepted(!termsAccepted);
                        }}
                    />
                )}

                <Button
                    variant={ButtonVariant.PRIMARY}
                    size={ButtonSize.LARGE}
                    text={
                        showDisclosures
                            ? 'I acknowledge and agree'
                            : isJointInvitation
                              ? 'Join this account'
                              : 'Open my account'
                    }
                    disabled={!termsAccepted && showDisclosures}
                    onPress={onSubmit}
                />
            </YStack>
        </YStack>
    );
};

export default ConfirmAccountOpen;
